import { Box, IconButton, MenuItem, ListItemText, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

export function ContentLanguageItem({ item, selected, onSelect, onDelete }) {
    return (
        <MenuItem selected={selected} onClick={handleClick} sx={{ px: 1.5, borderRadius: 0.75 }}>
            <ListItemText
                primary={item.name}
                secondary={item.nativeName}
                primaryTypographyProps={{ variant: "body2" }}
                secondaryTypographyProps={{ variant: "caption" }}
            />
            <Box sx={{ display: "flex", alignItems: "center", ml: "auto" }}>
                <If value={item.rtl}>
                    <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                        RTL
                    </Typography>
                </If>
                <If value={selected}>
                    <Iconify icon="mdi:check" sx={{ ml: 1, color: "primary.main" }} />
                </If>
                <If value={onDelete}>
                    <IconButton
                        aria-label="Remove language"
                        size="small"
                        onClick={handleDelete}
                        sx={{ ml: 0.5, p: 0.25 }}
                    >
                        <Iconify icon="mdi:close" sx={{ fontSize: 16, color: "text.disabled" }} />
                    </IconButton>
                </If>
            </Box>
        </MenuItem>
    )

    function handleClick() {
        onSelect(item)
    }

    function handleDelete(e) {
        e.stopPropagation()
        onDelete(item)
    }
}
